export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPokladna';
export const NAME = 'Pokladna';
